import { useState } from "react";
import { RichSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsRichProps = {
    settings: RichSettings;
    onChange: (settings: RichSettings) => void;
}

export const AppCustomPropertySettingsRich = ({settings, onChange} : AppCustomPropertySettingsRichProps) => {
    return (
        <div className="app-custom-property-settings-container">
            
        </div>
    )
}